import MdaePopover from "./component";
import { IPopoverOptions } from "devextreme-react/popover";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaePopoverProps extends IPopoverOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaePopover;
